import { TenantContext } from '@/components';
import { RoutePath } from '@/core/router';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

export const HomePage = () => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return (
    <Navigate
      replace
      to={
        !currentSelectedTenant?.organizations[0] ||
        currentSelectedTenant.organizations.length > 1
          ? RoutePath.organizations()
          : RoutePath.organizationDetail(
              currentSelectedTenant.organizations[0].toString(),
            )
      }
    />
  );
};
